import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import TopNavbar from './TopNavbar';
import SecondaryNavbar from './SecondaryNavbar';
import publicData from '../../../data/publicData.json';

const Navbar = ({ theme, companyInfo }) => {
  const { toggleTheme } = useTheme();

  return (
    <header className="sticky top-0 z-50">
      <TopNavbar 
        theme={theme}
        socialLinks={companyInfo?.socialLinks || {}}
        contactInfo={companyInfo?.contactInfo || {}}
        onToggleTheme={toggleTheme}
      />
      <SecondaryNavbar
        theme={theme}
        companyInfo={companyInfo}
      />
    </header>
  );
};

export default Navbar;
